module.exports = __webpack_public_path__ + "static/media/3rd.254c2e56.jpg";